<template>
  <div v-if="vacancy.is_hot"
       class="resume-active-responses__item-label  _hot">
    <BaseSvg name="ico-flame"
             width="0.8rem"
             height="1.2rem"/>
    <span v-if="vacancy[1].work_start_text">{{ vacancy[1].work_start_text }}</span>
  </div>
  <div v-else
       class="resume-active-responses__item-label">
    <BaseSvg name="ico-clock"
             width="1.4rem"
             height="1.4rem"/>
    <span v-if="vacancy[1].work_start_text">{{ vacancy[1].work_start_text }}</span>
  </div>
</template>

<script>
  export default {
    name: 'ResumeActiveResponsesItemLabel',
    props: {
      vacancy: Object
    },
    data() {
      return {

      }
    }
  }
</script>

<style lang="less">

</style>
